import React from 'react';
import Select from './select';

const TableSize = ({ pageSize, setPageSize }) => {
  if (!setPageSize) return null;
  return (
    <div className="table-size">
      Show
      <div className="margin-left-8">
        <Select
          options={[10, 25, 50, 100]}
          value={pageSize}
          onChange={setPageSize}
          variant="v2"
          size="sm"
        />
      </div>
      <div className="margin-left-8">items per page</div>
    </div>
  );
};

export default TableSize;
